<template>
  <div class="d-flex justify-content-center align-items-center error-container">
    <div class="text-center">
      <div class="faipay-fs">
        Payment did not go through please retry
        <!-- {{ failedMsg ? failedMsg : "Your Payment Failed" }} -->
      </div>

      <div class="text-center mt-4">
        <button class="btn retry-btn" @click="goToTypePage()">RETRY</button>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
export default {
  name: "Offers",

  components: {
    Slick
  },
  data() {
    return {
      type: "",
      typeID: ""
    };
  },
  mounted() {
    this.type = this.$route.params.type;
    this.typeID = this.$route.params.typeID;
    // this.getBookingDetails();
  },
  methods: {
    goToTypePage() {
      console.log(this.type, this.typeID);
      if (this.type == "event") {
        this.$router.push({
        name: "eventDetails",
        params: {
          eventID: this.typeID
        }
      });
      } else {
        this.$router.push({
        name: "movie",
        params: {
          movieID: this.typeID,
          cinemaID: "0",
        }
      });
      }
    
    }
  }
};
</script>

<style>
/* .modal-bg {
  width: 100%;
  position: fixed;
  z-index: 100000;
  margin: 0 0 auto auto;
  padding: 100px 0 0 0;
  height: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/retriedPayment.vue